import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { termsOfUse } from '@/shared/api/resources';
import { Alert } from '@/shared/ui/Alert';
import { Button } from '@/shared/ui/Button';

import { CHAVE_DO_TERMO_VIGENTE, TermsOfUseModal } from './TermsOfUseModal';

/**
 * O termo de uso na moldura da aplicacao (TER-008).
 *
 * O OnPoint chama a atribuicao do ultimo termo de uso na carga de cada tela. Aqui a
 * moldura le o termo vigente uma vez por sessao e reage ao que o servidor diz:
 *
 * - sem termo vigente, ou ja aceito, ou que nao vale para a pessoa: nada aparece;
 * - aceite obrigatorio ligado: o dialogo abre e nao fecha ate o aceite (ou a saida);
 * - aceite obrigatorio desligado (o padrao): um aviso convida a ler e aceitar.
 *
 * O bloqueio e da tela, como no OnPoint. O registro do aceite, que e a prova, e do
 * servidor. Falha na leitura nao bloqueia ninguem: o termo nao pode derrubar a
 * plataforma.
 */
export function TermsOfUseGate() {
  const [lendo, setLendo] = useState(false);
  const consulta = useQuery({
    queryKey: CHAVE_DO_TERMO_VIGENTE,
    queryFn: ({ signal }) => termsOfUse.current(signal),
    staleTime: 5 * 60_000,
    retry: false,
  });

  const situacao = consulta.data;
  if (!situacao?.must_accept || !situacao.version) return null;

  if (situacao.blocking) {
    return (
      <TermsOfUseModal
        open
        blocking
        version={situacao.version}
        onClose={() => undefined}
      />
    );
  }

  return (
    <div className="mb-5">
      <Alert tone="info" title="Termo de uso">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span>Ha um termo de uso vigente aguardando o seu aceite.</span>
          <Button size="sm" variant="secondary" onClick={() => setLendo(true)}>
            Ler o termo de uso
          </Button>
        </div>
      </Alert>
      <TermsOfUseModal
        open={lendo}
        blocking={false}
        version={situacao.version}
        onClose={() => setLendo(false)}
      />
    </div>
  );
}
